const classlink = {
  title: 'Integraciones · ClassLink',
  subtitle: 'Conexiones OneRoster con distritos de ClassLink',
  new_connection: 'Nueva conexión',
  empty: 'Todavía no hay conexiones ClassLink. Crea la primera con el botón "Nueva conexión".',
  loading: 'Cargando conexiones...',
  load_error: 'No se pudieron cargar las conexiones de ClassLink.',
  missing_secret: 'Falta el secret',

  unavailable: {
    title: 'Función no disponible',
    text: 'La administración de conexiones ClassLink todavía no está disponible en este ambiente. Vuelve a intentarlo cuando el backend esté desplegado.',
  },

  filters: {
    search: 'Buscar por nombre o tenant key',
    status: 'Estado',
    status_all: 'Todas',
    status_enabled: 'Habilitadas',
    status_disabled: 'Deshabilitadas',
    sync: 'Última sincronización',
    sync_all: 'Todas',
    sync_never: 'Nunca sincronizada',
    missing_secret: 'Solo con secret faltante',
    clear: 'Limpiar filtros',
    no_results: 'Ninguna conexión coincide con los filtros aplicados.',
  },

  table: {
    name: 'Nombre',
    tenant_key: 'Tenant key',
    enabled: 'Habilitado',
    schools: 'Colegios',
    courses: 'Cursos',
    students: 'Estudiantes',
    teachers: 'Docentes',
    staff: 'Personal',
    source: 'En ClassLink',
    last_sync: 'Última sincronización',
    actions: 'Acciones',
  },

  // Columna "En ClassLink". Son plurales de vue-i18n: se consumen con `$tc`,
  // no con `$t`.
  stats: {
    source_orgs: '{n} organización | {n} organizaciones',
    source_users: '{n} usuario | {n} usuarios',
    scoped_hint: 'Esta conexión tiene alcance configurado: no incluye el distrito entero',
  },

  enabled_switch: {
    on: 'Conexión habilitada',
    off: 'Conexión deshabilitada',
  },

  status: {
    running: 'En curso',
    success: 'Correcta',
    failed: 'Con error',
  },

  relative: {
    just_now: 'hace instantes',
    minutes: 'hace {n} min',
    hours: 'hace {n} h',
    days: 'hace {n} d',
  },

  run: {
    never: 'Nunca sincronizada',
    counts: '{users} usuarios, {courses} cursos, {skipped} omitidos, {ambiguous} ambiguos, {errors} errores',
  },

  actions: {
    sync: 'Sincronizar',
    sync_incremental: 'Incremental',
    sync_full: 'Completa',
    history: 'Ver historial',
    edit: 'Editar conexión',
    delete: 'Eliminar conexión',
  },

  sync: {
    started_incremental: 'Sincronización incremental iniciada',
    started_full: 'Sincronización completa iniciada',
  },

  form: {
    create_title: 'Nueva conexión ClassLink',
    edit_title: 'Editar conexión ClassLink',
    display_name: 'Nombre',
    tenant_key: 'Tenant key',
    tenant_key_hint: 'Subdominio de rosterserver.com. Solo minúsculas, dígitos y guiones.',
    tenant_key_readonly: 'El tenant key no se puede cambiar después del alta.',
    endpoint_url: 'Endpoint URL',
    endpoint_url_hint: 'Se completa solo a partir del tenant key. Cámbialo solo si el distrito usa otro dominio.',
    client_id: 'Client ID',
    client_secret: 'Client secret',
    client_secret_placeholder: 'Sin cambios · termina en {hint}',
    notes: 'Notas',
    test_connection: 'Probar conexión',
    test_ok: 'Conexión correcta (primera organización: {orgName})',
    test_ok_no_org: 'Conexión correcta.',
    test_hint: 'Puedes guardar sin probar, pero te recomendamos probar la conexión antes.',
    test_missing_fields: 'Completa endpoint URL, client ID y client secret para probar la conexión.',
    required: 'Este campo es requerido',
    tenant_key_invalid: 'Solo se admiten minúsculas, dígitos y guiones',
    url_invalid: 'Escribe una URL https válida',
    cancel: 'Cancelar',
    save: 'Guardar',
    created: 'Conexión creada',
    updated: 'Conexión actualizada',
  },

  runs: {
    title: 'Historial de sincronizaciones',
    subtitle: 'Últimas {limit} corridas de {name}',
    empty: 'Todavía no hay corridas registradas para esta conexión.',
    load_error: 'No se pudo cargar el historial.',
    close: 'Cerrar',
    col_started_at: 'Inicio',
    col_mode: 'Modo',
    col_trigger: 'Origen',
    col_status: 'Estado',
    col_duration: 'Duración',
    col_summary: 'Resumen',
    unresolved_title: 'Registros omitidos: {total}',
    unresolved_group: '{count} en la muestra — {reason}',
    mode: {
      incremental: 'Incremental',
      full: 'Completa',
    },
    trigger: {
      cron: 'Automática',
      manual: 'Manual',
    },
    triggered_by: 'Disparada por {email}',
    in_progress: 'En curso',
    duration_seconds: '{n} s',
    detail_title: 'Detalle por etapa',
    col_stage: 'Etapa',
    col_outcome: 'Resultado',
    col_count: 'Cantidad',
    errors_title: 'Muestra de errores',
    error_message_title: 'Error de la corrida',
    source_totals_title: 'Totales en ClassLink',
    source_totals: '{orgs} organizaciones · {users} usuarios · {classes} cursos · {enrollments} inscripciones',
    copy: 'Copiar',
    copied: 'Copiado al portapapeles',
    copy_failed: 'No se pudo copiar. Selecciona el texto y cópialo a mano.',
  },

  stages: {
    district: 'Distritos',
    school: 'Colegios',
    user: 'Usuarios',
    class: 'Cursos',
    enrollment: 'Inscripciones',
  },

  outcomes: {
    resolved: 'Resueltos',
    linked: 'Vinculados',
    created: 'Creados',
    ambiguous: 'Ambiguos',
    deactivated: 'Desactivados',
    skipped: 'Omitidos',
    error: 'Errores',
    notFound: 'No encontrados',
  },

  outcome: {
    applied: 'Correcta',
    no_changes: 'Sin cambios',
    needs_attention: 'Requiere atención',
  },

  reasons: {
    raw: '{text}',
    ambiguous_candidates: 'Hay más de un candidato posible en BeeReaders (ids: {candidates}). Revísalo y vincula el correcto a mano.',
    unexpected_error: 'Error inesperado: {message}',
    district_unresolved: 'Su distrito no se pudo resolver, así que este registro quedó sin sincronizar.',
    school_unresolved: 'Su colegio no se pudo resolver, así que este registro quedó sin sincronizar.',
    same_roster_as_representative: 'Tiene el mismo listado de alumnos que otro curso ({representative}), así que se unificaron en uno solo.',
    grade_unresolved: 'No se pudo determinar el grado ({kind}).',
    user_unresolved: 'Su usuario no se pudo resolver, así que la inscripción quedó sin sincronizar.',
    class_unresolved: 'Su curso no se pudo resolver, así que la inscripción quedó sin sincronizar.',
  },

  /**
   * Copy corto y sin parámetros para la vista agrupada de omitidos del drawer
   * (`unresolvedGroups`): un grupo junta la muestra de varios registros, así
   * que no corresponde mostrar los params de uno solo (ej. los ids de
   * `ambiguous_candidates`) como si fueran de todo el grupo. `reasons` (arriba)
   * sigue usándose donde se muestra un único registro (la muestra de errores).
   */
  reasons_grouped: {
    raw: 'Motivo registrado como texto libre',
    ambiguous_candidates: 'Hay más de un candidato posible en BeeReaders',
    unexpected_error: 'Error inesperado',
    district_unresolved: 'Su distrito no se pudo resolver',
    school_unresolved: 'Su colegio no se pudo resolver',
    same_roster_as_representative: 'Tiene el mismo listado de alumnos que otro curso',
    grade_unresolved: 'No se pudo determinar el grado',
    user_unresolved: 'Su usuario no se pudo resolver',
    class_unresolved: 'Su curso no se pudo resolver',
  },

  delete: {
    title: 'Eliminar conexión',
    confirm: 'Vas a eliminar la conexión {name} ({tenantKey}), que tiene {users} vinculados. La conexión dejará de sincronizarse. Los usuarios existentes no se borran.',
    users_count: '{count} usuarios',
    cancel: 'Cancelar',
    accept: 'Eliminar',
    deleted: 'Conexión eliminada',
  },

  last_attention: 'La última corrida con problemas fue {when}',
  mismatch: 'ClassLink reporta {users} usuarios y en BeeReaders no hay ningún estudiante sincronizado',

  reconcile: {
    title: 'Organizaciones sin vincular',
    subtitle: 'Decide con qué registro de BeeReaders se corresponde cada una',
    stale_source: 'ClassLink no respondió. Esto es lo que quedó de la última sincronización y puede estar desactualizado.',
    load_error: 'No se pudieron cargar las organizaciones sin vincular.',
    all_linked: 'Todas las organizaciones fueron vinculadas.',
    candidate_plain: '{name}',
    candidate_orphan: '{name} — está sin distrito asignado, por eso la sincronización no lo reconoce',
    candidate_inactive: '{name} — está inactivo, por eso la sincronización no lo reconoce',
    no_candidates: 'No hay ningún registro con este nombre en BeeReaders. Créalo primero: los distritos en Conglomerados y los colegios en Colegios.',
    link: 'Vincular',
    linked: 'Organización vinculada',
    link_error: 'No se pudo vincular la organización.',
    open: 'Revisar',
  },
  /**
   * Alcance de la sincronización (KB-950).
   *
   * `grade_labels` va por código y no derivado del ordinal: nueve códigos
   * (BIRTH, PRENATAL, IT, PR, PK, KG, PS, UG, OTHER) comparten `grade: 0`.
   * Las claves llevan el prefijo `g` (ver `gradeLabelKey`).
   */
  scope: {
    open: 'Alcance de la sincronización',
    title: 'Alcance de la sincronización',
    subtitle: 'Elige qué escuelas y qué grados entran en cada sincronización de esta conexión.',
    load_error: 'No se pudo cargar el alcance de la sincronización.',
    unavailable: 'El alcance de la sincronización todavía no está disponible en este ambiente. Vuelve a intentarlo cuando el backend esté desplegado.',
    stale_source: 'ClassLink no respondió. No se ven los nombres de las escuelas ni puedes cambiar la selección; abajo está lo que hay guardado. Lo único que puedes hacer ahora es quitar el filtro.',

    schools_title: 'Escuelas',
    schools_all: 'Esta conexión no tiene filtro de escuelas: hoy sincroniza el distrito entero.',
    schools_saved: 'Hoy sincroniza {n} escuela de {total}. | Hoy sincroniza {n} escuelas de {total}.',
    schools_saved_readonly: 'Hoy sincroniza {n} escuela. | Hoy sincroniza {n} escuelas.',
    schools_empty: 'El roster de esta conexión no trae ninguna escuela.',
    schools_search: 'Busca una escuela por nombre o identificador',
    schools_no_results: 'Ninguna escuela coincide con la búsqueda.',
    schools_hint: 'Si no eliges ninguna, se quita el filtro y vuelve a entrar el distrito entero.',
    schools_synced_breakdown: '{students} est. · {teachers} doc. · {staff} pers.',
    select_all: 'Seleccionar todas',
    select_none: 'Quitar todas',
    selected_count: 'Seleccionadas ahora: {n} de {total}',

    grades_title: 'Grados',
    grades_all: 'Esta conexión no tiene filtro de grados: hoy sincroniza todos.',
    grades_saved: 'Hoy sincroniza {n} grado. | Hoy sincroniza {n} grados.',
    grades_empty: 'El roster de esta conexión todavía no reporta grados. Sincroniza una vez para poder filtrarlos.',
    grades_hint: 'Si no eliges ninguno, entran todos los grados.',

    save: 'Guardar',
    cancel: 'Cancelar',
    clear: 'Quitar el filtro',
    saved: 'Alcance actualizado',
    save_error: 'No se pudo guardar el alcance.',
    unavailable_live: 'ClassLink no responde en este momento, así que no se puede guardar una selección de escuelas. Inténtalo de nuevo más tarde.',
    invalid_orgs: 'Alguna de las escuelas seleccionadas ya no existe en ClassLink. Vuelve a cargar la pantalla e inténtalo otra vez.',

    confirm_title: 'Confirma el cambio',
    confirm_body: 'Vas a dejar {excluded} escuela fuera de la sincronización; quedará {remaining} dentro. | Vas a dejar {excluded} escuelas fuera de la sincronización; quedarán {remaining} dentro.',
    confirm_note: 'Los registros de las escuelas y grados que quedan afuera se inactivan: dejan de verse y de sincronizarse. No se borra nada, y volver a incluirlos los reactiva.',
    preview_error: 'No se pudo calcular cuántos registros se van a inactivar. Puedes guardar igual, pero lo harás sin ese dato.',
    preview_deactivate_title: 'Se van a inactivar:',
    preview_users: '{count} alumno | {count} alumnos',
    preview_courses: '{count} curso | {count} cursos',
    preview_enrollments: '{count} inscripción | {count} inscripciones',
    preview_reactivate: 'Se va a reactivar {count} registro que estaba fuera del alcance. | Se van a reactivar {count} registros que estaban fuera del alcance.',
    confirm_accept: 'Guardar de todos modos',
    confirm_cancel: 'Cancelar',

    grade_labels: {
      gBIRTH: 'Nacimiento',
      gPRENATAL: 'Prenatal',
      gIT: 'Lactantes y primera infancia',
      gPR: 'Preescolar',
      gPK: 'Prekínder',
      gTK: 'Kínder de transición',
      gKG: 'Kínder',
      gPS: 'Educación superior',
      gUG: 'Sin grado asignado',
      gOTHER: 'Otro',
      g01: 'Grado 1',
      g02: 'Grado 2',
      g03: 'Grado 3',
      g04: 'Grado 4',
      g05: 'Grado 5',
      g06: 'Grado 6',
      g07: 'Grado 7',
      g08: 'Grado 8',
      g09: 'Grado 9',
      g10: 'Grado 10',
      g11: 'Grado 11',
      g12: 'Grado 12',
      g13: 'Grado 13',
    },
  },
};

export default classlink;
